import React, { Component } from "react";
import {
  Header,
  Grid,
  Segment,
  Button,
  Tab,
  Popup
} from "semantic-ui-react";

import ReactTable from "react-table";
import request from "../../utils/request";
import { AppContext } from "../../utils/context";
import PieChart from "../../components/common/PieChart";
import { StatsBox } from "../../components/common/StatsBox";
import { formatInt, formatCurrency } from "../../utils/constants";
import DrumPrinters from "../../components/settings/DrumPrinters"
import InlineEditField from "../../components/common/InlineEditField";

class EventSummary extends Component {
  _mounted = false;
  state = {
    loading: true,
    summary: {},
    pollInterval: false,
    previousAttendance: null,
    attendanceFocus: false,
    saveAttendanceResponse: null,
    shopifyPendingOrderLists: []
  };

  componentDidMount = () => {
    window.scrollTo(0, 0);
    this._mounted = true;
    this.pollData();
  };

  componentWillUnmount = () => {
    this._mounted = false;
    clearInterval(this.state.pollInterval);
  };

  startLoading = () => {
    this.setState({ loading: true });
  };

  doneLoading = () => {
    this.setState({ loading: false });
  };

  setAttendanceFocus = () => {
    this.setState({ attendanceFocus: true, saveAttendanceResponse: null });
  }
  setAttendanceBlur = () => {
    this.setState({ attendanceFocus: false }, () => this.saveAttendanceChange());
  }
  handleAttendanceChange = (newValue) => {
    let summary = this.state.summary;
    if (newValue == '' || /^[0-9\b]+$/.test(newValue)) {
      summary.attendance = newValue;
      this.setState({ summary: summary });
    }
  }
  saveAttendanceChange = () => {
    let attendance = this.state.summary.attendance;
    let previousAttendance = this.state.previousAttendance;
    if (attendance == previousAttendance) return;
    request.post(this, `api:/event/${this.props.eventId}/set-attendance`, { attendance: attendance }).then(resp => {
      let summary = this.state.summary;
      summary.per_cap = resp.per_cap;
      this.setState({ saveAttendanceResponse: "Attendance Saved", summary: summary });
    });
  };

  getShopifyPendingOrders = () => {
    request.get(this, `api:/event/${this.props.eventId}/get-shopify-pending-orders`).then(resp => {
      if (resp.success == true) {
        this.setState({ shopifyPendingOrderLists: resp.data });
      }
    });
  };

  downloadSummary = (e) => {
    return request.download(this, `api:/event/${this.props.eventId}/summary-export`, {'format': e.target.getAttribute('data-format')});
  };

  pollData = () => {
    let self = this;
    self.startLoading();
    return request
    .get(this, `api:/event/${this.props.eventId}`)
    .then(resp => {
        if (!this._mounted) return false;
        self.setState({
          event: resp
        });
        return resp;
      })
      .then(event => {
        if (!this._mounted) return false;
        request
          .get(this, `api:/event/${event.id}/summary`)
          .then(eventSummary => {
            if (!this._mounted) return false;
            eventSummary.dailySeller = eventSummary.daily_ranks;
            self.setState(prevState => {
              return {
                summary: eventSummary,
                previousAttendance: prevState.summary.attendance
              }
            }, self.doneLoading);
            return eventSummary;
          })
          .then(event => {
            self.handlePoll(event);
            return true;
          });
      });
  };
  handlePoll = resp => {
    if (!this._mounted) return false;
    if (resp.is_active === true) {
      if (!this.state.pollInterval) {
        let poll = setInterval(this.pollData, 15000);
        this.setState({
          pollInterval: poll
        });
      }
    }
  };

  render() {
    const { loading, summary, event, saveAttendanceResponse } = this.state;
    const { config } = this.context;
    const { rsuEnabled } = this.props;
    let salesTitle = "Net Sales: ";
    salesTitle += formatCurrency(summary.sales ? summary.sales.net : 0, config.language);
    let expensesTitle = "Total Expenses: ";
    expensesTitle += formatCurrency(summary.expenses ? summary.expenses.total : 0, config.language, 2);
    let prices = summary.prices ? summary.prices : [];
    let paymentData = [];
    let paymentLabels = [];
    let pieColors = ["#012C61", "#275287", "#4E79AE", "#749FD4", "#38005F", "#5E2685", "#854DAC", "#AB73D2", "#143000", "#3A5626", "#617D4D", "#87A373"]; // 4 blues, 4 purples, 4 greens
    prices.map((p, k) => {
      paymentData.push({ x: `${p.quantity} for ${formatCurrency(p.amount, config.language)}`, y: p.total_sets });
      return paymentLabels.push({ name: `${p.quantity} for ${formatCurrency(p.amount, config.language)}` });
    });
    let expenseData = [];
    let expenseLabels = [];
    let expenseToolTips = [];
    if (summary.expenses) {
      if (config.fixed_expenses_enabled) {
        expenseData.push({
          x: "Flat",
          y: summary.expenses ? +summary.expenses.flat : 0,
        });
        expenseLabels.push({name: "Flat"});
        expenseToolTips.push({ name: "Flat is the \n Bump license fee" });
      }
      expenseData.push(
        {
          x: "Fixed",
          y: summary.expenses ? +summary.expenses.venue_total : 0,
        },
        {
          x: "Credit Card",
          y: summary.expenses ? +summary.expenses.credit_card : 0,
        },
        {
          x: "Debit Card",
          y: summary.expenses ? +summary.expenses.debit_card : 0,
        }
      );
      expenseLabels.push({name: "Fixed"}, {name: "Credit Card"}, {name: "Debit Card"});
      expenseToolTips.push(
        { name: "Fixed is any additional \n expenses or hard costs to be \n removed from raffle" },
        { name: "Credit Card Fees \n (% per sale amount \n + cost per transaction)" },
        { name: "Debit Card Fees \n (% per sale amount \n + cost per transaction)" }
      );
    }

    const paymentsTableStyle =  { fontWeight: "bold" };
    const RenderPendingOrders = () => {
      return (
          <div>
            <h4>Pending Orders</h4>
            <ul>
              {Object.entries(this.state.shopifyPendingOrderLists).map(([orderId, orderUrl], index) => (
                <li key={index}>
                  <a href={orderUrl} target="_blank" rel="noopener noreferrer">
                    {orderId}
                  </a>
                </li>
              ))}
            </ul>
          </div>
      );
    };
    return (
      <Segment basic>
        <div className="summaryPageExportBtn">
            <Button primary content="Export PDF Summary" onClick={e => this.downloadSummary(e)} data-format="pdf" floated="right" />
            <Button primary content="Export CSV Summary" onClick={e => this.downloadSummary(e)} data-format="csv" floated="right" />
        </div>
        <Grid stretched stackable columns={rsuEnabled < 1 ? 3 : 4}>
          <Grid.Column>
            <Segment loading={loading}>
              <PieChart
                title={salesTitle}
                data={[
                  { x: "Cash", y: summary.sales ? +summary.sales.cash : 0 },
                  { x: "Credit", y: summary.sales ? +summary.sales.credit : 0 },
                  { x: "Debit", y: summary.sales ? +summary.sales.debit : 0 }
                ]}
                labels={[{ name: "Cash" }, { name: "Credit" }, { name: "Debit" }]}
                colors="green"
              />
            </Segment>
          </Grid.Column>
          <Grid.Column>
            <Segment loading={loading}>
              <PieChart
                title={"Payments by ticket set"}
                data={paymentData}
                labels={paymentLabels}
                colors={pieColors}
              />
            </Segment>
          </Grid.Column>
          {rsuEnabled > 0 && <Grid.Column>
            <Segment loading={loading} style={{overflow: 'auto', height: 100 }} className="pieChartSeller">
                <Tab panes={[
                  {
                    menuItem: {
                      key: 'rank',
                      content: <span>Seller Rank</span>
                    },
                    render: () =>
                    <Tab.Pane>
                        {summary.ranks && summary.ranks.length > 0 && (
                            <Grid>
                            <Grid.Row />
                            {summary.ranks.map(s => (
                            <Grid.Row
                              key={s.id}
                              verticalAlign="middle"
                              style={{ backgroundColor: s.rank === 1 ? "var(--color-primary-500" : "transparent",
                                       color: s.rank === 1 ? "white" : "inherit",
                                       fontSize: s.rank === 1 ? "1.2em" : "inherit",
                                       boxShadow: s.rank === 1 ? "0px 2px 4px rgba(0, 0, 0, .4)" : "none"
                                    }}
                            >
                              <Grid.Column width={2}>{s.rank}.</Grid.Column>
                              <Grid.Column width={9}>{s.name}</Grid.Column>
                              <Grid.Column width={5} textAlign="right">
                                    {formatCurrency(s.amount, config.language)}
                              </Grid.Column>
                            </Grid.Row>
                      ))}
                      </Grid>
                      )}
                    </Tab.Pane>,
                    },
                    {
                      menuItem: {
                        key: 'daily rank',
                        content: <span>Daily Seller Rank</span>
                      },
                      render: () =>
                      <Tab.Pane>
                        {summary.daily_ranks && summary.daily_ranks.length > 0 && (
                            <Grid>
                            <Grid.Row />
                            {summary.daily_ranks.map(s => (
                            <Grid.Row
                              key={s.id}
                              verticalAlign="middle"
                              style={{backgroundColor:s.rank === 1 ? "var(--color-primary-500" : "transparent",
                                      color: s.rank === 1 ? "white" : "inherit",
                                      fontSize: s.rank === 1 ? "1.2em" : "inherit",
                                      boxShadow: s.rank === 1 ? "0px 2px 4px rgba(0, 0, 0, .4)" : "none"
                                    }}
                            >
                              <Grid.Column width={2}>{s.rank}.</Grid.Column>
                              <Grid.Column width={9}>{s.name}</Grid.Column>
                              <Grid.Column width={5} textAlign="right">
                                  {formatCurrency(s.amount, config.language)}
                              </Grid.Column>
                            </Grid.Row>
                    ))}
                    </Grid>
                    )}
                    </Tab.Pane>
                    },
                  ]}
                />
            </Segment>
          </Grid.Column>}
          <Grid.Column>
            <Segment loading={loading}>
              <PieChart
                title={expensesTitle}
                data={expenseData}
                labels={expenseLabels}
                tooltips={expenseToolTips}
                colors="red"
              />
            </Segment>
          </Grid.Column>
          <Grid.Column mobile={16} tablet={16} computer={config && config.backend_type === "bep" ? 12 : 16}>
            <Segment>
              <Header>Details</Header>
              <Grid doubling columns={4}>
                <Grid.Column>
                  <StatsBox
                    label="Gross Sets"
                    value={summary.sets ? summary.sets.total : 0}
                  />
                </Grid.Column>
                <Grid.Column>
                  <StatsBox
                    label="Void Sets"
                    value={summary.sets ? summary.sets.void : 0}
                  />
                </Grid.Column>
                <Grid.Column>
                  <StatsBox
                    label="Net Sets"
                    value={summary.sets ? summary.sets.net : 0}
                  />
                </Grid.Column>
                {(config && config.allow_freeTicket || summary.sets && summary.sets.free > 0) &&
                  <Grid.Column>
                    <StatsBox
                      label="Free"
                      value={summary.sets ? summary.sets.free : 0}
                    />
                  </Grid.Column>
                }
                <Grid.Column>
                  <StatsBox
                    label="Gross Numbers"
                    value={summary.tickets ? summary.tickets.total : 0}
                  />
                </Grid.Column>
                <Grid.Column>
                  <StatsBox
                    label="Ecomm In Venue Sale"
                    value={summary.sales ? summary.sales.ecom_in_venue_sales : 0}
                  />
                </Grid.Column>
                <Grid.Column>
                  <StatsBox
                    label="Ecomm In Venue Sale Amount"
                    value={formatCurrency(summary.sales ? summary.sales.ecom_in_venue_sales_amount : 0, config.language)}
                  />
                </Grid.Column>
                <Grid.Column>
                  <StatsBox
                    label="Void Numbers"
                    value={summary.tickets ? summary.tickets.voids : 0}
                  />
                </Grid.Column>
                <Grid.Column>
                  <StatsBox
                    label="Net Numbers"
                    value={summary.tickets ? summary.tickets.net : 0}
                  />
                </Grid.Column>
                {event && +event.shopify_enabled === 1 && event.shopify_storefront !== "" &&
                  (<Grid.Column>
                    <StatsBox
                      label="Shopify pending orders "
                      value={event.pending_shopify_count ? event.pending_shopify_count : 0}
                      shopifyPendingOrders={event.pending_shopify_count ? event.pending_shopify_count : 0} 
                      renderPopupContent={RenderPendingOrders} 
                      onShowPendingOrdersClick={this.getShopifyPendingOrders}
                    />
                  </Grid.Column>)
                }
                {config && config.web_sales_enabled && (<Grid.Column>
                  <StatsBox
                    label="Orders In Progress"
                    value={summary.pending_order_count  ? summary.pending_order_count : 0}
                  />
                </Grid.Column>)
                }
                {config && config.web_sales_enabled && (<Grid.Column>
                  <StatsBox
                    label="Order Emails In Progress"
                    value={summary.pending_order_email_count  ? summary.pending_order_email_count : 0}
                  />
                </Grid.Column>)
                }
                <Grid.Column>
                  <StatsBox
                    label="Reprints"
                    value={summary.tickets && summary.tickets.reprints ? summary.tickets.reprints : 0}
                  />
                </Grid.Column>
                {config && config.backend_type === "bep" && (<Grid.Column>
                  <StatsBox
                    label="Printer Queue"
                    value={summary.printer_queue ? summary.printer_queue : 0}
                  />
                </Grid.Column>)
                }
                <Grid.Column>
                  <InlineEditField
                    label="Attendance"
                    type="number"
                    value={summary.attendance}
                    hasFocus={this.state.attendanceFocus}
                    handleChange={this.handleAttendanceChange}
                    setBlur={this.setAttendanceBlur}
                    setFocus={this.setAttendanceFocus}
                    saveChange={saveAttendanceResponse}
                  />
                </Grid.Column>
                <Grid.Column>
                  <StatsBox
                    label="Per Cap"
                    value={summary.per_cap}
                  />
                </Grid.Column>
                { summary.has_subscription &&
                  (<Grid.Column>
                  <StatsBox
                    label="New Subscriptions During Event"
                    value={summary.new_subscriptions_from_current_event}
                  />
                </Grid.Column>)} 
                { summary.has_subscription &&
                  ( <Grid.Column>
                  <StatsBox
                    label="Total Active Subscriptions During Event"
                    value={summary.total_active_subscriptions}
                  />
                  </Grid.Column>)
                }
                { summary.has_subscription &&
                  ( <Grid.Column>
                  <StatsBox
                    label="Total Cancelled Subscriptions Up to Date"
                    value={summary.total_cancelled_subscriptions}
                  />
                  </Grid.Column>)
                }

              </Grid>
            </Segment>
          </Grid.Column>
          {(config && config.backend_type === "bep") &&
          (<Grid.Column mobile={16} tablet={16} computer={4}>
            <DrumPrinters printers={summary.printers} loading={loading} pollData={this.pollData} />
          </Grid.Column>)
          }
          <Grid.Column width={16}>
            <Segment>
              <Header>Payments by ticket set</Header>
              <ReactTable
                data={summary.prices}
                columns={[
                  {
                    id: "quantity",
                    Header: "Set",
                    minWidth: 50,
                    accessor: d => d.quantity + " for " + formatCurrency(d.amount, config.language),
                    Footer: (
                      <span style={paymentsTableStyle}>
                        Totals:
                      </span>
                    )
                  },
                  {
                    id: "totalSets",
                    accessor: d => formatInt(d.total_sets),
                    Header: "# of printed",
                    minWidth: 50,
                    Footer: (
                      <span style={paymentsTableStyle}>
                        {summary.sets ? formatInt(summary.sets.net) : 0}
                      </span>
                    )
                  },
                  {
                    id: "totalTickets",
                    accessor: d => formatInt(d.total_tickets),
                    Header: "Numbers in draw",
                    minWidth: 50,
                    Footer: (
                      <span style={paymentsTableStyle}>
                        {summary.tickets ? formatInt(summary.tickets.net) : 0}
                      </span>
                    )
                  },
                  {
                    id: "salesPC",
                    accessor: d => Math.round(d.sales_pc) + "%",
                    Header: "% of Sales",
                    minWidth: 50,
                    Footer: (
                      <span style={paymentsTableStyle}>
                        {summary.sales ? summary.sales.net > 0 ? '100%' : '0%' : '0%'}
                      </span>
                    )
                  },
                  {
                    id: "pricePointPC",
                    accessor: d => Math.round(d.pricepoint_pc) + "%",
                    Header: "% of Set Usage",
                    minWidth: 50,
                    Footer: (
                      <span style={paymentsTableStyle}>
                        {summary.sets ? summary.sets.net > 0 ? '100%' : '0%' : '0%'}
                      </span>
                    )
                  },
                  {
                    id: "totalCash",
                    accessor: d => formatCurrency(d.total_cash, config.language),
                    Header: "Cash Sales",
                    minWidth: 50,
                    Footer: (
                      <span style={paymentsTableStyle}>
                        {formatCurrency(summary.sales ? summary.sales.cash : 0, config.language)}
                      </span>
                    )
                  },
                  {
                    id: "totalCredit",
                    accessor: d => formatCurrency(d.total_credit, config.language),
                    Header: "Credit Sales",
                    minWidth: 50,
                    Footer: (
                      <span style={paymentsTableStyle}>
                        {formatCurrency(summary.sales ? summary.sales.credit : 0, config.language)}
                      </span>
                    )
                  },
                  {
                    id: "totalDebit",
                    accessor: d => formatCurrency(d.total_debit, config.language),
                    Header: "Debit Sales",
                    minWidth: 50,
                    Footer: (
                      <span>
                        {formatCurrency(summary.sales ? summary.sales.debit : 0, config.language)}
                      </span>
                    )
                  },
                  {
                    id: "totalCost",
                    accessor: d => formatCurrency(d.total_cost, config.language),
                    Header: "Total Sales",
                    minWidth: 50,
                    Footer: (
                      <span style={paymentsTableStyle}>
                        {formatCurrency(summary.sales ? summary.sales.net : 0, config.language)}
                      </span>
                    )
                  }
                ]}
                className="-striped -highlight"
                getTableProps={() => ({
                  style: {
                    textAlign: "center"
                  }
                })}
                showPagination={false}
                pages={Math.ceil(summary.prices / 100)} // Display the total number of pages
                loading={loading} // Display the loading overlay when we need it
                onFetchData={this.fetchData} // Request new data when things change
                resizable={false}
                filterable={false}
                defaultPageSize={100}
                minRows={0}
              />
            </Segment>
          </Grid.Column>
          <Grid.Column width={16}>
            <Segment>
              <Header>Payments by Locations</Header>
              <ReactTable
                data={summary.locations}
                columns={[
                  {
                    id: "quantity",
                    Header: "Location Name",
                    minWidth: 50,
                    accessor: d => d.location_name == null ? "No Location": d.location_name,
                    Footer: (
                      <span style={paymentsTableStyle}>
                        Totals:
                      </span>
                    )
                  },
                  {
                    id: "totalSets",
                    accessor: d => formatInt(d.total_sets),
                    Header: "# of printed",
                    minWidth: 50,
                    Footer: (
                      <span style={paymentsTableStyle}>
                        {summary.sets ? formatInt(summary.sets.net) : 0}
                      </span>
                    )
                  },
                  {
                    id: "totalTickets",
                    accessor: d => formatInt(d.total_tickets),
                    Header: "Numbers in draw",
                    minWidth: 50,
                    Footer: (
                      <span style={paymentsTableStyle}>
                        {summary.tickets ? formatInt(summary.tickets.net) : 0}
                      </span>
                    )
                  },
                  {
                    id: "salesPC",
                    accessor: d => Math.round(d.sales_pc) + "%",
                    Header: "% of Sales",
                    minWidth: 50,
                    Footer: (
                      <span style={paymentsTableStyle}>
                        {summary.sales ? summary.sales.net > 0 ? '100%' : '0%' : '0%'}
                      </span>
                    )
                  },
                  {
                    id: "pricePointPC",
                    accessor: d => Math.round(d.location_pc) + "%",
                    Header: "% of Set Usage",
                    minWidth: 50,
                    Footer: (
                      <span style={paymentsTableStyle}>
                        {summary.sets ? summary.sets.net > 0 ? '100%' : '0%' : '0%'}
                      </span>
                    )
                  },
                  {
                    id: "totalCash",
                    accessor: d => formatCurrency(d.total_cash, config.language),
                    Header: "Cash Sales",
                    minWidth: 50,
                    Footer: (
                      <span style={paymentsTableStyle}>
                        {formatCurrency(summary.sales ? summary.sales.cash : 0, config.language)}
                      </span>
                    )
                  },
                  {
                    id: "totalCredit",
                    accessor: d => formatCurrency(d.total_credit, config.language),
                    Header: "Credit Sales",
                    minWidth: 50,
                    Footer: (
                      <span style={paymentsTableStyle}>
                        {formatCurrency(summary.sales ? summary.sales.credit : 0, config.language)}
                      </span>
                    )
                  },
                  {
                    id: "totalDebit",
                    accessor: d => formatCurrency(d.total_debit, config.language),
                    Header: "Debit Sales",
                    minWidth: 50,
                    Footer: (
                      <span>
                        {formatCurrency(summary.sales ? summary.sales.debit : 0, config.language)}
                      </span>
                    )
                  },
                  {
                    id: "totalCost",
                    accessor: d => formatCurrency(d.total_cost, config.language),
                    Header: "Total Sales",
                    minWidth: 50,
                    Footer: (
                      <span style={paymentsTableStyle}>
                        {formatCurrency(summary.sales ? summary.sales.net : 0, config.language)}
                      </span>
                    )
                  }
                ]}
                className="-striped -highlight"
                getTableProps={() => ({
                  style: {
                    textAlign: "center"
                  }
                })}
                showPagination={false}
                pages={Math.ceil(summary.locations / 100)} // Display the total number of pages
                loading={loading} // Display the loading overlay when we need it
                onFetchData={this.fetchData} // Request new data when things change
                resizable={false}
                filterable={false}
                defaultPageSize={100}
                minRows={0}
              />
            </Segment>
          </Grid.Column>
        </Grid>
      </Segment>
    );
  }
}
EventSummary.contextType = AppContext;
export default EventSummary;
